import React, {useMemo} from 'react';
import useI18n from "i18n/useI18n";
import { Dropdown } from '@etiquette-ui/inputs-dropdowns';
import { PRICING_ESTRATEGIES_TRANSLATIONS } from 'pages/MenuItems/pages/Items/resources/constants';

//Add custom selected option here

const PricingMethodSelect = ({ pricingStrategy, setPricingStrategy }) => {
  const { translate, translateObject, selectedLang } = useI18n();

  const pricingStrategiesOptions = useMemo(()=>{
    return Object.entries(translateObject(PRICING_ESTRATEGIES_TRANSLATIONS)).map( ([key, value]) => ({
      value: key,
      label: value
    }));
  },[selectedLang]);

  const selectedtOption = useMemo(() => {
    if(!pricingStrategy) return pricingStrategiesOptions[0];

    return pricingStrategiesOptions.find( option => option.value === pricingStrategy);
  }, [pricingStrategy, pricingStrategiesOptions])

  return (
    <Dropdown
      className='pricing-method'
      selectProps={{
        onChange: (selectedOption) => {
          setPricingStrategy(selectedOption.value);
        },
        initValue: pricingStrategiesOptions[0],
        options: pricingStrategiesOptions,
        value: selectedtOption,
      }}
      labelProps={{
        label: translate('Pricing Method'),
      }}
      containerProps={{
        styles: {
          minWidth: '250px',
          maxWidth: '400px',
          width: '100%'
        }
      }}
    />
  )
};
export default PricingMethodSelect;